import {Button} from '@hm/fundamental'
import {mdiPlus} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {ShutdownStatus, ShutdownType} from '@refra/modules/common/enums'
import {useShutdowns} from '@refra/modules/common/providers'
import type {NewShutdown} from '@refra/modules/common/types'

export const KilnShutdownsActions: React.FC = () => {
  const {t} = useTranslation()

  const {newShutdown, setNewShutdown} = useShutdowns()

  const isUserAddingNewShutdown = newShutdown !== null

  const onAddNewShutdown = () => {
    const newKilnShutdown: NewShutdown = {
      id: undefined,
      name: '',
      shutdownType: ShutdownType.RegularReplacement,
      shutdownStatus: ShutdownStatus.Draft,
      interventionDate: '',
      feedingDate: undefined
    }
    return setNewShutdown(newKilnShutdown)
  }

  return (
    <div data-cy="kiln_shutdowns_card_actions">
      <Button
        icon={mdiPlus}
        variant="tertiary"
        disabled={isUserAddingNewShutdown}
        onClick={onAddNewShutdown}
        data-cy="kiln_shutdowns_card_new_shutdown_button"
      >
        {t('refraPlanning.kilnShutdown.newShutdown')}
      </Button>
    </div>
  )
}
